import './Tab.scss';

import React, { ReactNode, useContext, useEffect } from 'react';

interface ITabContext {
  isActive: boolean;
  setIsActive: () => void;
}

export const TabContext = React.createContext<ITabContext>({} as ITabContext);

export interface ITabProps {
  name: string;
  children: ReactNode | ReactNode[];
  active?: boolean;
}

function Tab({ children, active }: ITabProps) {
  const { isActive, setIsActive } = useContext(TabContext);

  useEffect(() => {
    if (active) {
      setIsActive();
    }
  }, [active]);

  if (!isActive) {
    return null;
  }
  return (
    <section className="modTab" role="tabpanel">
      {children}
    </section>
  );
}

export default Tab;
